let current_index = null;

document.addEventListener("click", function (e) {
	 if (e.target.closest(".filter-dropdown-list li") == null && e.target.closest(".filter--dropdown") == null) {
    	$(".filter-dropdown-list").hide();
    }
})

$(document).ready(function () {
  
  
  $(document).on("click", function (e) {
    if ($(e.target).closest(".filter-dropdown-list li").length === 0 && $(e.target).closest(".filter--dropdown").length === 0) {
    	$(".filter-dropdown-list").hide();
    }
  })
  
  $(".filter--dropdown").on("click", function (e) {
   let index = $(".filter--dropdown").index(this);
   // console.log('Matched target:', $(e.target).closest(".filter-dropdown-list").length )
    
    current_index != null && current_index != index ? $(".filter-dropdown-list").eq(current_index).hide() : null;
    
    if ($(e.target).closest(".filter-dropdown-list").length === 0) {     	
    	$(this).find(".filter-dropdown-list").toggle();   
    } 
    
    
    current_index = index;
  })
  
  $(".filter--dropdown select").on("change", function () {
  	const index = $(".filter--dropdown select").index(this);
    
    let filter_dropdown = $(".filter--dropdown").eq(index);
    
    let options = filter_dropdown.find("select option");
    
    options.map(index => options.eq(index).attr('value') == $(this).val() ? options.eq(index).attr('selected', 'selected') : options.eq(index).removeAttr('selected'));

    
  })
  
  $(".filter-dropdown-list li").on("click", function () {
    let value = $(this).data('value');
    let filter_dropdown_list  = $(this).parent(), list_index = $(".filter-dropdown-list").index(filter_dropdown_list);
    
    let filter_dropdown = $(".filter--dropdown").eq(list_index);

    filter_dropdown.find(".current-selected").text($(this).text());
    
    filter_dropdown_list.hide();
  })
})